import { useBetslipStore } from "@/features/betslip/stores/betslipStore";

/**
 * Once placed, the price the server took.
 */
export const useAcceptedOdds = (outcomeId: string) =>
  useBetslipStore((s) => {
    const result = s.selectionResults[outcomeId];
    return result?.status === "accepted" ? result.odds : undefined;
  });
